export async function cancelGeneration(generationId: string): Promise<boolean> {
    try {
        if (!generationId) return false;
        const resp = await fetch('/api/generation/cancel', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ generationId }),
        });
        return resp.ok;
    } catch {
        return false;
    }
}
